module.exports = __webpack_public_path__ + "static/overcast-2913939599cf2ff77a625fab672af4e6.png";